import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'
import { HTML_LINK_TARGET } from '../../../../constants/html'
import { useIsUserProfileNGAvailable } from '../../../../hooks'
import { getQaSelector } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import {
  getUserListItemContentAdditionalText,
  getUserProfileRoute,
} from '../../../../utils/user'
import { FloatingTooltip, FloatingTooltipContentText } from '../../../Floating'
import { Link } from '../../../Link'
import Text from '../../../Text'
import { QA_NAME_ENTITY_PROFILE_TAB_UPDATES_OWNER_NAME } from '../EntityProfileTabUpdates.constants'

import * as styles from './EntityProfileTabUpdatesCardOwnerName.module.css'

function EntityProfileTabUpdatesCardOwnerName({ isInteractive, name, owner }) {
  const { t } = useTranslation()

  const isUserProfileNGAvailable = useIsUserProfileNGAvailable()

  const roleSuffix = isInteractive
    ? getUserListItemContentAdditionalText({
        companyPostName: owner?.company_post_name,
        group: owner?.group,
      })
    : null

  const textName = <Text className={styles.staticName}>{name}</Text>

  const linkQaProps = getQaSelector({
    value: QA_NAME_ENTITY_PROFILE_TAB_UPDATES_OWNER_NAME,
  })

  return (
    <div className={styles.EntityProfileTabUpdatesCardOwnerName}>
      <FloatingTooltip
        content={
          <FloatingTooltipContentText
            additionalText={t('Common.ClickToOpenProfileKey')}
            text={name}
          />
        }
        disabled={!isInteractive}
        placement={FLOATING_ELEMENT_PLACEMENT.top}
      >
        {isInteractive ? (
          <Link
            {...linkQaProps}
            className={styles.link}
            target={HTML_LINK_TARGET.blank}
            to={getUserProfileRoute({
              id: owner.id,
              isUserProfileNGAvailable,
              role: owner.group,
            })}
            onClick={stopPropagation}
          >
            {textName}
          </Link>
        ) : (
          textName
        )}
      </FloatingTooltip>
      &nbsp;
      {roleSuffix ? (
        <Text className={styles.roleSuffix}>{roleSuffix}</Text>
      ) : null}
    </div>
  )
}

export default EntityProfileTabUpdatesCardOwnerName
